var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "login-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center mb-4"
  }, [_c('div', {
    staticClass: "col-12 text-center"
  }, [_c('h2', {
    style: {
      color: '#fff',
      fontWeight: 'bold',
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.9)'
    }
  }, [_vm._v(" " + _vm._s(_vm.tagline) + " ")])])]), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "card rounded-lg"
  }, [_c('b-row', {
    staticClass: "mt-2 ml-2"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "pl-4 pr-5"
  }, [_c('h4', {
    staticClass: "d-flex align-items-center"
  }, [_c('router-link', {
    attrs: {
      "button": "",
      "to": "/login-with"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "arrow-left-short"
    }
  })], 1), _vm._v(" " + _vm._s(_vm.$t("login")) + " ")], 1), _c('p', {}, [_vm._v(" " + _vm._s(_vm.$t("logintoDiscover")) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.$t("newTo")) + " " + _vm._s(_vm.appName) + "? "), _c('router-link', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("createAccount")) + " ")])], 1)])])], 1), _c('div', {
    staticClass: "card-body pl-5 pr-5"
  }, [!_vm.otpKey && _vm.loginType !== 'otp' ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v(_vm._s(_vm.$t("contactUs.email")) + " :")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phone,
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "phone",
      "type": "text",
      "placeholder": _vm.$t('contactUs.emailPlaceholder'),
      "required": ""
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.phone = $event.target.value;
      }
    }
  })]) : _vm._e(), !_vm.otpKey && _vm.loginType == 'otp' ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v(_vm._s(_vm.$t("contactUs.phone")) + " :")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phone,
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "phone",
      "type": "text",
      "placeholder": _vm.$t('contactUs.phonePlaceholder'),
      "required": ""
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "keydown": _vm.handlePhoneKey,
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.phone = $event.target.value;
      }
    }
  })]) : _vm._e(), !_vm.otpKey && _vm.loginType !== 'otp' ? _c('div', {
    staticClass: "form-group position-relative"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t("password")) + " :")]), (_vm.showPassword ? 'text' : 'password') === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    staticClass: "form-control pr-5",
    attrs: {
      "id": "password",
      "placeholder": _vm.$t('password'),
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : _vm.password
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.password = $$c;
        }
      }
    }
  }) : (_vm.showPassword ? 'text' : 'password') === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    staticClass: "form-control pr-5",
    attrs: {
      "id": "password",
      "placeholder": _vm.$t('password'),
      "required": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "change": function ($event) {
        _vm.password = null;
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    staticClass: "form-control pr-5",
    attrs: {
      "id": "password",
      "placeholder": _vm.$t('password'),
      "required": "",
      "type": _vm.showPassword ? 'text' : 'password'
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.password = $event.target.value;
      }
    }
  }), _c('span', {
    staticClass: "toggle-password",
    on: {
      "click": _vm.togglePasswordVisibility
    }
  }, [_c('i', {
    class: _vm.showPassword ? 'mdi mdi-eye-off' : 'mdi mdi-eye'
  })])]) : _vm._e(), !_vm.otpKey && _vm.loginType !== 'otp' ? _c('div', {
    staticClass: "text-right pb-2"
  }, [_c('router-link', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "to": "/forgot-password"
    }
  }, [_vm._v(_vm._s(_vm.$t("forgotPassword")))])], 1) : _vm._e(), _vm.otpKey ? _c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('form', {
    staticClass: "mt-4 mb-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.otpInput1,
      expression: "otpInput1"
    }],
    staticClass: "otp border",
    attrs: {
      "type": "text",
      "maxlength": "1"
    },
    domProps: {
      "value": _vm.otpInput1
    },
    on: {
      "keyup": function ($event) {
        return $event.target.nextElementSibling.focus();
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.otpInput1 = $event.target.value;
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.otpInput2,
      expression: "otpInput2"
    }],
    staticClass: "otp border",
    attrs: {
      "type": "text",
      "maxlength": "1"
    },
    domProps: {
      "value": _vm.otpInput2
    },
    on: {
      "keyup": function ($event) {
        return $event.target.nextElementSibling.focus();
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.otpInput2 = $event.target.value;
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.otpInput3,
      expression: "otpInput3"
    }],
    staticClass: "otp border",
    attrs: {
      "type": "text",
      "maxlength": "1"
    },
    domProps: {
      "value": _vm.otpInput3
    },
    on: {
      "keyup": function ($event) {
        return $event.target.nextElementSibling.focus();
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.otpInput3 = $event.target.value;
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.otpInput4,
      expression: "otpInput4"
    }],
    staticClass: "otp border",
    attrs: {
      "type": "text",
      "maxlength": "1"
    },
    domProps: {
      "value": _vm.otpInput4
    },
    on: {
      "keyup": function ($event) {
        return $event.target.nextElementSibling.focus();
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.otpInput4 = $event.target.value;
      }
    }
  })]), _c('p', {
    style: {
      color: _vm.otpMsg.key
    }
  }, [_vm._v(" " + _vm._s(_vm.otpMsg.value) + " ")])])]) : _vm._e(), _c('div', {
    staticClass: "pt-4 form-group text-center"
  }, [!_vm.isLoading ? [!_vm.otpKey && _vm.loginType !== 'otp' ? _c('b-button', {
    staticClass: "primary-btn",
    attrs: {
      "size": "lg"
    },
    on: {
      "click": function () {
        return _vm.loginWithPsw();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("signIn")) + " ")]) : _vm._e(), _vm.otpKey || _vm.loginType == 'otp' ? _c('b-button', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    },
    attrs: {
      "size": "lg"
    },
    on: {
      "click": function () {
        return _vm.loginOtp();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("loginwithOTP")))]) : _vm._e()] : _vm._e(), _vm.isLoading ? _vm._l(3, function (i) {
    return _c('b-spinner', {
      key: i,
      staticClass: "mr-1",
      attrs: {
        "small": "",
        "label": "Small Spinner",
        "type": "grow"
      }
    });
  }) : _vm._e()], 2), !_vm.otpKey ? _c('div', {
    staticClass: "d-flex justify-content-center align-item-center mt-4 mb-3"
  }) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-center gap-6 mt-4"
  }, [_vm.loginType == 'otp' ? _c('b-button', {
    staticClass: "circle-btn border",
    attrs: {
      "variant": "light"
    },
    on: {
      "click": function () {
        _vm.$route.query.type = 'email';
        _vm.loginType = 'email';
        _vm.otpKey = false;
        _vm.phone = '';
      }
    }
  }, [_c('b-icon', {
    staticClass: "me-2",
    attrs: {
      "icon": "envelope-fill"
    }
  })], 1) : _c('b-button', {
    staticClass: "circle-btn border",
    attrs: {
      "variant": "light"
    },
    on: {
      "click": function ($event) {
        _vm.loginType = 'otp';
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "telephone-fill",
      "font-scale": "1.2"
    }
  })], 1), _c('b-button', {
    staticClass: "circle-btn border",
    attrs: {
      "variant": "light"
    },
    on: {
      "click": _vm.googleLogin
    }
  }, [_c('img', {
    staticClass: "icon-img",
    attrs: {
      "src": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg",
      "alt": "Google"
    }
  })]), _c('b-button', {
    staticClass: "circle-btn border",
    attrs: {
      "variant": "light"
    },
    on: {
      "click": _vm.facebookLogin
    }
  }, [_c('img', {
    staticClass: "icon-img",
    attrs: {
      "src": "https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png",
      "alt": "Facebook"
    }
  })])], 1)])], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }